import { render, staticRenderFns } from "./Key_Skills.vue?vue&type=template&id=399a936e&scoped=true&"
import script from "./Key_Skills.vue?vue&type=script&lang=js&"
export * from "./Key_Skills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a936e",
  null
  
)

export default component.exports